import { PawPrint, BadgeCheck, MapPin } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

const newShelters = [
  { name: "Schronisko dla Bezdomnych Zwierząt", city: "Katowice" },
  { name: 'Schronisko "Arka" ŁTOZ', city: "Łomża" },
  { name: "Ochota na Kota", city: "Warszawa" },
  { name: "Stowarzyszenie Cztery Łapy", city: "Olecko" },
];

export const InstagramStory4Verified1 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "linear-gradient(180deg, rgba(78,138,110,0.06) 0%, rgba(45,90,61,0.10) 100%)",
          zIndex: 1,
        }}
      />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          padding: "280px 60px 280px",
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "48px" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "14px",
              background: "#4E8A6E",
              borderRadius: "100px",
              padding: "16px 40px",
              marginBottom: "28px",
            }}
          >
            <BadgeCheck style={{ width: "36px", height: "36px", color: "#FFFFFF" }} />
            <span style={{ fontSize: "34px", fontWeight: 700, color: "#FFFFFF" }}>
              NOWE WERYFIKACJE
            </span>
          </div>
          <h1 style={{ fontSize: "72px", fontWeight: 800, color: "#2D5A3D", margin: 0, lineHeight: 1 }}>
            4 nowe schroniska
          </h1>
          <p style={{ fontSize: "40px", fontWeight: 700, color: "#4E8A6E", margin: "12px 0 0" }}>
            się zweryfikowały! 🎉
          </p>
        </div>

        {/* Shelter cards */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            justifyContent: "center",
          }}
        >
          {newShelters.map((shelter, i) => (
            <div
              key={i}
              style={{
                background: "rgba(255,255,255,0.97)",
                borderRadius: "24px",
                padding: "32px 36px",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                boxShadow: "0 6px 24px rgba(0,0,0,0.06)",
                border: "2px solid rgba(78,138,110,0.15)",
              }}
            >
              <div
                style={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "16px",
                  background: "#4E8A6E",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <BadgeCheck style={{ width: "30px", height: "30px", color: "#FFFFFF" }} />
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "4px", minWidth: 0 }}>
                <span
                  style={{
                    fontSize: "30px",
                    fontWeight: 700,
                    color: "#2D5A3D",
                    lineHeight: 1.2,
                  }}
                >
                  {shelter.name}
                </span>
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <MapPin style={{ width: "20px", height: "20px", color: "#6B8A7A" }} />
                  <span style={{ fontSize: "24px", fontWeight: 500, color: "#6B8A7A" }}>
                    {shelter.city}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div style={{ textAlign: "center", marginTop: "48px" }}>
          <div
            style={{
              background: "linear-gradient(135deg, #5D9A7D 0%, #4E8A6E 100%)",
              borderRadius: "24px",
              padding: "28px 40px",
              marginBottom: "24px",
            }}
          >
            <p style={{ fontSize: "32px", fontWeight: 700, color: "#FFFFFF", margin: 0 }}>
              Sprawdź jakie mają potrzeby! 💚
            </p>
          </div>

          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
            <div
              style={{
                background: "#4E8A6E",
                borderRadius: "14px",
                width: "44px",
                height: "44px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PawPrint style={{ width: "26px", height: "26px", color: "#FFFFFF" }} />
            </div>
            <span style={{ fontSize: "30px", fontWeight: 800, color: "#2D5A3D" }}>
              GdzieSchronisko.pl
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
